import React, { Component } from 'react'
import Sidebar from '../multi/Sidebar'

class Living extends Component {
  render = () => {
    return (
      <div>

        <div className="heroLiving vh-25 flex justify-end vh-50-ns">
          <div className="heroText pathway ma3 pa3 bg-black self-end near-white f4 f3-ns">
            Eureka Missouri is currently the #1 tourist destination in Saint Louis County!
          </div>
        </div>


        <div id="maincontent" className="w-100 pa2 bg-moon-gray flex flex-column flex-row-l items-start-l">

          <Sidebar/>

          <div id="content" className="w-100 pl2-l">

          <article className="pa4 mb3 bg-white">
              <div className="head pathway w-100 flex flex-row justify-between items-end bb2">
                <div className="title f3 f2-m f1-l">
                Check out some of our local attractions!
                </div>
              </div>
              <hr className="w-100 mt1 mb3"/>
              <div className="bod droid f5 lh-copy">
                  <a className="link db dark-blue hover-moon-gray mb2 mt4" 
                     href="https://www.sixflags.com/stlouis">
                     Visit Six Flags Amusement park right here in town!
                  </a>    
                     Book a campout for the whole family at one of our beautiful outdoor resorts!
                    <ul>
                      <li> 
                        <a className="link db dark-blue hover-moon-gray mb2" 
                        href="http://www.eurekajellystone.com/">
                        Jellystone
                      </a>
                      </li>
                      <li> 
                        <a className="link db dark-blue hover-moon-gray mb2" 
                        href="http://koa.com/campgrounds/st-louis-west/">
                        Koa campgrounds
                      </a>
                      </li>
                    </ul>
                  <a className="link db dark-blue hover-moon-gray mb2" 
                     href="http://www.franciscancaring.org/blackmadonnashri.html">
                     Go take in some tremendous religious history at the Black Madonna shrine!
                  </a>
                  <a className="link db dark-blue hover-moon-gray mb2" 
                     href="http://www.endangeredwolfcenter.org/">
                     Plan a visit to the Endangered Wolf Center!
                  </a>
                  <a className="link db dark-blue hover-moon-gray mb2" 
                     href="http://www.brookdalefarmsinc.com/">
                     There are terrific events all year long at our very own Brookdale farms!
                  </a>
                  <a className="link db dark-blue hover-moon-gray mb2" 
                     href="http://www.hiddenvalleyski.com/">
                     Visit Hidden Valley for skiing and tubing (weather permitting)!
                  </a>
                  <a className="link db dark-blue hover-moon-gray mb2" 
                     href="http://wymancenter.org/">
                     Read all about the history of Camp Wyman and the programs they offer!
                  </a>
                  <a className="link db dark-blue hover-moon-gray mb2" 
                     href="http://www.santasmagicalkingdom.com/">
                     Visit one of the greatest holiday light shows in the entire state at Santa’s Magical Kingdom!  (Season Hours)
                  </a>
                  <a className="link db dark-blue hover-moon-gray mb2" 
                     href="https://mostateparks.com/park/route-66-state-park">
                     Enjoy one of Eureka’s many parks!
                  </a>
              </div>
            </article>

          </div>
        </div>
      </div>
    )
  }
}

export default Living


// WEBPACK FOOTER //
// ./src/components/pages/Living.js